/* eslint-disable max-lines-per-function */
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import Table from '../../components/layout/Table'
import vanBangProcessor from '../../processor/vanBangProcessor'

const ListVanBang = (props) => {
  const { khoaThiId, donViDangKyDuThiId, heDaoTaoId, hinhThucDaoTaoId } = useSelector((item) => {
    const { khoaThi, donViDangKyDuThi, heDaoTao, hinhThucDaoTao } = item
    return {
      khoaThiId: khoaThi.id,
      donViDangKyDuThiId: donViDangKyDuThi.id,
      heDaoTaoId: heDaoTao.id,
      hinhThucDaoTaoId: hinhThucDaoTao.id,
    }
  })
  const { column, datas, setDatas, paging } = props
  const { setPaging, selected, setSelected, reload, setReload } = props
  let { state, name, getMethod } = props
  const processor = vanBangProcessor
  state = state || 0
  name = name || ''
  getMethod = getMethod || processor.getByKhoaThi
  const getVanBangChuaDuyet = async () => {
    if (khoaThiId || (props.getKhoaThi && props.getNam)) {
      const rs = await getMethod({
        khoaThiId,
        skip: 0,
        take: paging.take,
        heDaoTaoId,
        hinhThucDaoTaoId,
        donViDangKyDuThiId,
        state,
        name,
      })
      setDatas(rs.values)
      setPaging({ skip: rs.skip, take: rs.take, total: rs.totalItemsCount })
    }
  }

  useEffect(getVanBangChuaDuyet, [
    heDaoTaoId,
    hinhThucDaoTaoId,
    donViDangKyDuThiId,
    state,
    khoaThiId,
    name,
  ])
  useEffect(async () => {
    if (reload === true && setReload) {
      getVanBangChuaDuyet()
      setReload(false)
    }
  }, [reload])

  const getVanBangChuaDuyetWithSkip = async (skip) => {
    const rs = await getMethod({
      khoaThiId,
      skip,
      take: paging.take,
      heDaoTaoId,
      hinhThucDaoTaoId,
      donViDangKyDuThiId,
      state,
      name,
    })
    setPaging({
      skip: rs.skip,
      take: rs.take,
      total: rs.totalItemsCount,
      heDaoTaoId,
      hinhThucDaoTaoId,
      donViDangKyDuThiId,
    })
    setDatas(rs.values)
  }
  const getVanBangChuaDuyetWithTake = async (take) => {
    const rs = await getMethod({ khoaThiId, skip: 0, take })
    setPaging({
      skip: rs.skip,
      take: rs.take,
      total: rs.totalItemsCount,
      heDaoTaoId,
      hinhThucDaoTaoId,
      donViDangKyDuThiId,
      state,
      name,
    })
    setDatas(rs.values)
  }
  const pagingChange = (e) => {
    if (paging.skip !== e.first) {
      getVanBangChuaDuyetWithSkip(e.first)
    }
    if (paging.take !== e.rows) {
      getVanBangChuaDuyetWithTake(e.rows)
    }
  }
  return (
    <Table
      data={datas}
      column={column}
      lazy
      setPaging={pagingChange}
      selected={selected}
      setSelected={setSelected}
      {...paging}
    />
  )
}
export default ListVanBang
